module.exports = __webpack_public_path__ + "assets/img/701.876688f4.png";